import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Classification } from '@synergy/models';
import { Dispatch } from 'redux';
import { PaginatedResponse, isDomainError } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ErrorMessage } from '../../../../../common/models/enums/error-message';

export const CLASSIFICATIONS_REQUEST = 'CLASSIFICATIONS_REQUEST';
export const CLASSIFICATIONS_RECEIVED = 'CLASSIFICATIONS_RECEIVED';
export const CLASSIFICATION_DELETE = 'CLASSIFICATION_DELETE';
export const CLASSIFICATION_UPDATE = 'CLASSIFICATION_UPDATE';
export const CLASSIFICATION_CREATE = 'CLASSIFICATION_CREATE';
export const CLASSIFICATION_CREATED = 'CLASSIFICATION_CREATED';
export const CLASSIFICATION_FAILED = 'CLASSIFICATION_FAILED';
export const CLASSIFICATION_DELETE_ERROR = 'CLASSIFICATION_DELETE_ERROR';
export const CLASSIFICATION_DELETE_ERROR_CLEAR = 'CLASSIFICATION_DELETE_ERROR_CLEAR';

export const clearDeleteError = () => ({
    type: CLASSIFICATION_DELETE_ERROR_CLEAR,
});

const receivedClassification = (classifications: PaginatedResponse<Classification>) => {
    return {
        type: CLASSIFICATIONS_RECEIVED,
        classifications,
    };
};

const createdClassification = (classification: Classification) => {
    return {
        type: CLASSIFICATION_CREATED,
        classification,
    };
};

export const fetchClassifications = (searchParams?: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CLASSIFICATIONS_REQUEST });

        const response = await api.classifications.cget(searchParams);

        if (response.success) {
            dispatch(receivedClassification(response.result));
        } else {
            dispatch({ type: CLASSIFICATION_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchAllClassifications = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CLASSIFICATIONS_REQUEST });

        const response = await api.classifications.cgetAll();

        if (response.success) {
            dispatch(receivedClassification(response.result));
        } else {
            dispatch({ type: CLASSIFICATION_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deleteClassification = (classificationId: number) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.classifications.deleteClassification(classificationId);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.classificationDeleted')));
            dispatch({ type: CLASSIFICATION_DELETE, classificationId });
        } else {
            const error = response.error;
            if (isDomainError(error) && error.title === ErrorMessage.CannotDeleteClassification) {
                dispatch({ type: CLASSIFICATION_DELETE_ERROR, classificationId });
            } else {
                dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            }
        }
    };
};

export const updateClassification = (classification: Classification) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CLASSIFICATION_UPDATE, classification });
        const response = await api.classifications.updateClassification(classification);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.updated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const createClassification = (classification: Partial<Classification>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CLASSIFICATION_CREATE });
        const response = await api.classifications.createClassification(classification);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.classificationCreated')));
            dispatch(createdClassification(response.result));
        } else {
            dispatch({ type: CLASSIFICATION_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
